// Who is signed in and which groups they are in, for the pages that only some groups may open.
// The server answers about whoever signed the call (/api/v1/user/), never about a name the browser
// sends. A 401 (sign-in expired) is handled once, in main.js: sign out and go to the login page.
import axios from 'axios'

export const PLANNING = 1
export const CASH = 3

// the groups saved by the last check, to draw the menu before the server answers
export function savedGroups () {
  return (localStorage.getItem('userGroups') || '').split(',').filter(Boolean).map(Number)
}

// put the groups in the store's isPlaning / isCashAccountant
export function showGroups (store, groups) {
  store.commit('setIsPlaning', groups.includes(PLANNING))
  store.commit('setIsCashAccountant', groups.includes(CASH))
}

// ask the server, save the answer and show it; throws when the server can't be asked
export async function refreshGroups (store) {
  const { data } = await axios.get('/api/v1/user/')
  const groups = data.groups || []
  localStorage.setItem('userGroups', groups)
  showGroups(store, groups)
  return groups
}

// a page for some groups only: true when the user is in one of them, else sends them home
export async function mayUse (store, router, allowed) {
  try {
    if ((await refreshGroups(store)).some(group => allowed.includes(group))) return true
  } catch (error) {
    // no answer: the server refuses the page's data anyway
  }
  router.push('/')
  return false
}
